import LeadCardTag from './LeadCardTag.component';

export default LeadCardTag;